<template>
  <div class="app">
    <header-item />
    <main class="container">
      <side-menu v-if="loginPage" class="desc-menu" />
      <router-view class="main-view" />
    </main>
    <footer-item class="main-footer" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import HeaderItem from "../src/components/HeaderItem.vue";
import FooterItem from "../src/components/FooterItem.vue";
import SideMenu from "../src/components/SideMenu.vue";
import NavLoader from "../src/views/NavLoader.vue";
import { useRouter, useRoute } from "vue-router";

export default defineComponent({
  name: "App",
  components: {
    HeaderItem,
    FooterItem,
    SideMenu,
  },
  setup() {
    const loading = ref(false);
    const router = useRouter();
    const route = useRoute();

    return {
      loading,
    };
  },

  data() {
    return {
      loader: false,
    };
  },

  created() {
    console.log(document.documentElement.clientWidth);
    this.setPageTitle();
  },
  computed: {
    pageTitle() {
      const routeName = this.$route.path;
      let title;
      if (routeName == "/" || routeName == "/login") {
        title = "Вход в личный кабинет";
      } else {
        title = "Личный кабинет";
      }
      return title;
    },
    loginPage() {
      if (this.$route.path == "/login" || this.$route.path == "/") {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    pageTitle: "setPageTitle",
  },
  methods: {
    setPageTitle() {
      document.title = this.pageTitle;
    },
  },
});
</script>

<style lang="scss">
$main-backg-color: #e9e9e9;

@mixin main-view($main-backg-color) {
  margin: 10px 5px 0 5px;
  min-height: 100vh;
  background-color: $main-backg-color;
}

@font-face {
  font-family: "Roboto";
  src: local("Roboto Regular"), local("Roboto-Regular"),
    url("./assets/fonts/Roboto/Roboto-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "Roboto";
  src: local("Roboto Medium"), local("Roboto-Medium"),
    url("./assets/fonts/Roboto/Roboto-Medium.ttf") format("truetype");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "Roboto";
  src: local("Roboto Bold"), local("Roboto-Bold"),
    url("./assets/fonts/Roboto/Roboto-Bold.ttf") format("truetype");
  font-weight: 700;
  font-style: normal;
}

#app {
  margin: 0;
  padding: 0;
  background-color: #e9e9e9;
  overflow: hidden;
  min-width: 360px;
  font-family: "Roboto";
  min-height: 100vh + 20vh;
  position: relative;
  padding-bottom: 114px;
}

.main-footer {
  position: absolute;
  bottom: 0;
}

.main-view {
  @include main-view($main-backg-color);
}

@media screen and (max-width: 767px) {
  .desc-menu {
    display: none;
  }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .desc-menu {
    display: none;
  }
}

@media screen and (min-width: 1025px) {
  .container {
    display: flex;
    justify-content: space-around;
    max-width: 1260px;
    margin-right: auto;
    margin-left: auto;
  }

  .main-view {
    min-width: 67%;
  }

  .desc-menu {
    margin-top: 10px;
  }

  .menu-hide {
    display: none;
  }
}
</style>
